<div class="flex flex-col gap-1 pl-2">
  <div class="typo-h4-medium leading-none text-text-primary">{{ item().drugName }}</div>
  <div class="typo-h7-medium leading-none text-text-light">{{ item().description }}</div>
</div>
<div class="typo-h4-medium flex leading-none text-text-primary">
  <div class="w-[104px] py-2 pl-2">{{ item().providerId }}</div>
  <div class="w-32 py-2 pl-2">{{ item().prescriptionDate | date: 'dd/MM/yyyy' }}</div>
  <div class="w-11 py-2 pl-2"><lib-prescriptions-ns-icon [status]="item().nsStatus"></lib-prescriptions-ns-icon></div>
</div>
